import {request} from "@/api/request";

const state = {
    IsCurator: false,
};

const getters = {
    getIsCurator: state => state.IsCurator,

};

const mutations = {
    updateIsCurator(state, obj) {
        state.IsCurator = obj.value;
    },
    resetIsCurator(state) {
        state.IsCurator = false;
    },
};

const actions = {
    setIsCurator({commit, rootState}, {mb_no}) {
        let params = {
            no : mb_no
        }
        request.get('member/info', params)
            .then((res) => {
                let result = res.data.Data.Result;
                if (result.Info.type > 0 && result.List.length > 0) {
                    let curator = result.List[0].g_idx === 2
                    commit('updateIsCurator', {'value':curator });
                } else {
                    commit('updateIsCurator', {'value': false})
                }

            }, () => {
                console.log('error');
            })
    },
    initIsCurator({commit, rootState}, {data}) {
        commit('resetIsCurator');
    },
};

export default {namespaced: true, state, getters, mutations, actions}
